import { NgModule, ModuleWithProviders } from '@angular/core';
import { FooterComponent } from './components/footer/footer.component';
import { SharedModule } from '../shared/shared.module';
import { HttpClientModule } from '@angular/common/http';
import { HeaderEnjoyClComponent } from './components/header-enjoy-cl/header-enjoy-cl.component';
import { LayoutEnjoyClComponent } from './components/layout-enjoy-cl/layout-enjoy-cl.component';

@NgModule({
  imports: [
    SharedModule,
    HttpClientModule
  ],
  declarations: [
    FooterComponent,
    HeaderEnjoyClComponent,
    LayoutEnjoyClComponent,
  ],
  exports: [
    FooterComponent,
    HeaderEnjoyClComponent,
    LayoutEnjoyClComponent
  ]
})
export class LayoutModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: LayoutModule
    };
  }
}

